var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 116,
    viewBox: "0 0 117 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 212836522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.2645 18.0703C9.87753 24.7974 5.08722 33.0547 2.5 42.2348L58.3318 58.0003L16.2645 18.0703Z",
    fill: "#21223D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M0.332031 57.9999C0.332031 52.5351 1.08805 47.2471 2.50072 42.2344L58.3326 57.9999L65.7006 115.536C63.2567 115.846 60.7958 116 58.3325 116C35.541 116 15.82 102.854 6.33805 83.7309C2.49344 75.9773 0.332031 67.2409 0.332031 57.9999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.333 57.9998C116.333 61.1274 116.083 64.2501 115.584 67.3377L58.332 57.9998L69.6189 1.09766C96.2489 6.34988 116.333 29.8294 116.333 57.9998Z",
    fill: "#63658E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.584 67.3377C111.504 92.5433 91.1802 112.306 65.6994 115.536L58.332 57.9998L115.584 67.3377Z",
    fill: "#63658E"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.2695 18.0718L58.3368 58L69.6237 1.0978C65.906 0.3659 62.1259 -0.00177222 58.3368 6.42224e-06C41.7773 0.00181722 26.838 6.94216 16.2695 18.0718Z",
    fill: "#CBD5E1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pieChart.b1449fb84702ee3590f0d8ef3d895c1c.svg";
export { ForwardRef as ReactComponent };